<template>
  <el-select
    v-if="confidenceLevels && confidenceLevels.length > 0"
    id="ddlConfidence"
    v-model="confidenceLevel"
    collapse-tags
    collapse-tags-tooltip
    clearable
    class="bg-dark"
    placeholder="Filter by confidence level"
    size="large"
    style="{width: 300px;}"
    @change="$emit('selected-confidence-id', confidenceLevel)"
  >
    <el-option
      v-for="{ id, name } in confidenceLevels"
      :key="id"
      :label="name"
      :value="id"
    >
      <span class="text-capitalize">{{ name }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "ProfileConfidenceDropdown",
  props: {
    selected: {
      type: Number,
      default: -1,
    },
  },
  emits: ["selected-confidence-id"],
  setup(props) {
    let confidenceLevel = ref(props.selected);
    if (confidenceLevel.value == -1) {
      confidenceLevel.value = "";
    }
    watch(
      () => props.selected,
      (current) => {
        if (current == -1) confidenceLevel.value = "";
        else confidenceLevel.value = current;
      }
    );
    return { confidenceLevel };
  },
  data() {
    return {
      confidenceLevels: [
        {
          id: 1,
          name: "High",
        },
        {
          id: 2,
          name: "Medium",
        },
        {
          id: 3,
          name: "Low",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
html.dark .el-select {
  width: 270px;
}
</style>
